import Vue from 'vue'
import './plugins/axios'
import Antd from 'ant-design-vue';
import App from './App.vue'
import './plugins/ant-design-vue.js'
import store from './store'
import router from './router'
import VueI18n from 'vue-i18n' 
import zh from './locales/zh'
import en from './locales/en'
import zhCN from 'ant-design-vue/es/locale/zh_CN';
import enUS from 'ant-design-vue/es/locale/en_US';

Vue.config.productionTip = false

Vue.use(VueI18n)

const i18n = new VueI18n({
    locale: 'zh', 
    messages: {
        'zh': {
            ...zh,  
            ...zhCN  
        },
        'en': {
            ...en,  
            ...enUS  
        }
    }
})

Vue.use(Antd)

new Vue({
    store,
    router,
    i18n,  // 注入i18n实例
    render: h => h(App)
}).$mount('#app')